import { ProtocolSettings } from "./ProtocolSettings";
import { ProtocolSettingsTypes } from "./ProtocolSettingsTypes";
import { ObjUtils } from "../Utils/ObjUtils";
	
export class AwsSettings extends ProtocolSettings {

	public AccessKey: string;
	public SecretKey: string;
	public Region: string;

	constructor() {
		super();

		this.AccessKey = "";
		this.SecretKey = "";
		this.Region = "";
	}

	public get HasAccessKey(): boolean {
		return !!this.AccessKey;
	}

	public get HasSecretKey(): boolean {
		return !!this.SecretKey;
	}

	public get HasRegion(): boolean {
		return !!this.Region;
	}

	public get SettingsType(): string {
		return ProtocolSettingsTypes.AWS;
	}

	public get Summary(): string {
		return `AccessKey: ${this.AccessKey}; Region: ${this.Region}`;
	}

	public Copy(obj: ProtocolSettings): void {
		if (!(obj instanceof AwsSettings))
			return;
		let other = (obj as AwsSettings);

		super.Copy(obj);

		this.AccessKey = other.AccessKey;
		this.SecretKey = other.SecretKey;
		this.Region = other.Region;
	}

	public Clone(): ProtocolSettings {
		let clone = new AwsSettings();
		clone.Copy(this);
		return clone;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof AwsSettings))
			return false;
		let other: AwsSettings = (obj as AwsSettings);

		return (ObjUtils.Equals(this.AccessKey, other.AccessKey) &&
			ObjUtils.Equals(this.SecretKey, other.SecretKey) &&
			ObjUtils.Equals(this.Region, other.Region));
	}

	public Write(obj: any, context: any): void {
		obj.aws = {};
		obj = obj.aws;

		super.Write(obj, context);

		if (this.HasAccessKey)
			obj.access_key = this.AccessKey;

		if (this.HasSecretKey)
			obj.secret_key = this.SecretKey;

		if (this.HasRegion)
			obj.aws_region = this.Region;
	}

	public Read(obj: any, context: any): void {
		if (!obj.aws)
			throw new Error();
		obj = obj.aws;

		super.Read(obj, context);

		if (obj.acess_key !== undefined)
			this.AccessKey = obj.acess_key;
		if (obj.access_key !== undefined)
			this.AccessKey = obj.access_key;

		if (obj.secret_key !== undefined)
			this.SecretKey = obj.secret_key;

		if (obj.aws_region !== undefined)
			this.Region = obj.aws_region;
	}

}

